import { Briefcase, ShieldCheck, BookOpenCheck, Check } from "lucide-react";
import { Reveal, Chapter } from "@/components/site/Reveal";
import { PILLARS } from "@/data/content";

const ICONS = [Briefcase, ShieldCheck, BookOpenCheck];

export default function Solution() {
  return (
    <section id="solution" className="relative bg-ink">
      <div className="pointer-events-none absolute inset-0" aria-hidden="true">
        <div className="absolute left-0 top-1/3 h-[420px] w-[420px] rounded-full bg-gold/[0.05] blur-[130px]" />
      </div>
      <div className="relative mx-auto max-w-7xl px-6 py-28 lg:px-10 lg:py-36">
        <Chapter n="Chapter 02" label="The VERIVISTA Triad" dark />
        <Reveal>
          <h2 className="max-w-3xl text-balance font-serif text-3xl font-medium leading-tight tracking-tight text-ivory sm:text-4xl lg:text-5xl">
            One command. <span className="italic text-gold">Three disciplines.</span>
          </h2>
        </Reveal>
        <Reveal delay={0.15}>
          <p className="mt-8 max-w-2xl text-base leading-relaxed text-mist sm:text-lg">
            Commercial Management, Project Audit and Project Accounting — integrated under a single
            oversight, engineered exclusively for screen and media productions.
          </p>
        </Reveal>

        <div className="mt-16 grid gap-6 lg:grid-cols-3">
          {PILLARS.map((p, i) => {
            const Icon = ICONS[i];
            return (
              <Reveal key={p.n} delay={0.1 + i * 0.14}>
                <article
                  data-testid={`solution-pill-${i + 1}`}
                  className="group relative h-full border border-white/10 bg-abyss/60 p-9 transition-all duration-500 hover:border-gold/40 hover:bg-elevated/60"
                >
                  <div className="flex items-center justify-between">
                    <Icon size={26} strokeWidth={1.25} className="text-gold" />
                    <span className="font-serif text-3xl italic text-gold/40">{p.n}</span>
                  </div>
                  <h3 className="mt-8 font-serif text-2xl font-medium text-ivory">{p.title}</h3>
                  <p className="mt-4 text-sm leading-relaxed text-mist">{p.body}</p>
                  <ul className="mt-8 space-y-3 border-t border-white/10 pt-6">
                    {p.points.map((pt) => (
                      <li key={pt} className="flex items-start gap-3 text-sm text-ivory/80">
                        <Check size={14} className="mt-1 shrink-0 text-gold" strokeWidth={2} />
                        {pt}
                      </li>
                    ))}
                  </ul>
                  <span className="absolute inset-x-0 top-0 h-px w-0 bg-gold transition-all duration-700 group-hover:w-full" aria-hidden="true" />
                </article>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
